import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import styles from './social-network-nav.module.css'

const SocialNetworkNav = () => {
  const data = useStaticQuery(graphql`
    query SocialQuery {
      site {
        siteMetadata {
          social {
            twitter
            facebook
            instagram
          }
        }
      }
    }
  `)
  const { social } = data.site.siteMetadata
  
  return (
    <div className={styles.navContainer}>
      <div className={styles.nav}>
        <a href={`https://twitter.com/${social.twitter}`}>Twitter</a>
        <a href={`https://facebook.com/${social.facebook}`}>Facebook</a>
        <a href={`https://instagram.com/${social.instagram}`}>Instagram</a>
      </div>
    </div>
  )
}

export default SocialNetworkNav
